// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"0fffc81f","3788":"0fffc81f","4574":"5898ebfb"}[chunkId] + ".chunk.css";
};